export const AWARD_PLACES = [
  { place: 'Winner' },
  { place: 'Second Place' },
  { place: 'Third Place' },
  { place: 'Fourth Place' }
];

export const NUMERICAL_AWARD_PLACES = [{place: '1'}, {place: '2'}, {place: '3'}, {place: '4'}]